function setCartAndWishlistToLocalStorage(customerId,pageName){
  updateCartLocalStorage(customerId,pageName);
  updateWishlistLocalStorage(customerId,pageName);
  setLocalStorage()
}

var localStorageObj = {};
var localStorageCartLineItemsArray = [];
var localStorageWishlistLineItemsArray = [];

var responseCartObj = {};
var responseWishlistArray = [];

function updateCartLocalStorage(customerId,pageName){
  var pageNumber = 0;
  var pageLimit = 250;
  //     var getCartItemsUrl = cartBaseUrl+getCartItemsEndPoint+customerId+"?page="+pageNumber+"&limit="+pageLimit;
  var getCartItemsUrl = cartBaseUrl+getCartItemsEndPoint+customerId+"?page="+pageNumber+"&limit="+pageLimit;
  $.ajax({
    type: 'GET',
    async:true,
    dataType: 'json',
    contentType: 'application/json',
    headers:getV3Header(),
    error: function (data) {
      console.log(data);
      var responseErrorObj = JSON.parse(data.responseText);
      var errorObj = responseErrorObj.error;
      var errorMessage = errorObj.message;
      Sentry.captureMessage('Error in '+pageName+' updateCartLocalStorage function'+errorMessage);
      Sentry.captureException(data);
      swal({
        title: '',
        text: errorMessage,
        type: 'error',
        confirmButtonText: 'OK',
        closeOnCancel: false,
        allowOutsideClick: false
      });
    },
    url: getCartItemsUrl,
    statusCode: {
      200: function (data) {
        // sentry Breadcrumb info
        Sentry.addBreadcrumb({
          type: 'http',
          category: 'Cart',
          message: 'successfully recieved cart lineitems response',
          level: 'info'
        });
        responseCartObj = data;
        createCartLocalStorageObj();
      },
      302: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in '+pageName+' updateCartLocalStorage function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          closeOnCancel: false,
          allowOutsideClick: false
        });
        $('.swal2-confirm').click(function () {
          location.reload(true);
        });
      },
      401:function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in '+pageName+' updateCartLocalStorage function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
      },
      403: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in '+pageName+' updateCartLocalStorage function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
      },
      400: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in '+pageName+' updateCartLocalStorage function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });

      },
      500: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in '+pageName+' updateCartLocalStorage function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
      }
    }
  }).fail(function(data, textStatus, xhr){
    console.log(data.getResponseHeader('x-request-id'));
  });
}

function updateWishlistLocalStorage(customerId,pageName){
  //   v3getWishlistProductsEndPoint
  //   var getWishlist = cartBaseUrl+getWishlistEndPoint+customerId;
  var getWishlist = cartBaseUrl+v3getWishlistProductsEndPoint+customerId+"?limit=250";
  $.ajax({
    async:false,
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    //               headers: v2Header,
    headers: getV3Header(customerId),
    error: function (data) {
      console.log(data)
      var responseErrorObj = JSON.parse(data.responseText);
      var errorObj = responseErrorObj.error;
      var errorMessage = errorObj.message;
      Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
      Sentry.captureException(data);
      swal({
        title: 'Sorry',
        text: errorMessage,
        type: 'error',
        confirmButtonText: 'OK',
        closeOnCancel: false,
        allowOutsideClick: false
      });
    },
    url: getWishlist,
    statusCode: {
      200: function (data) {
        if(!($.isEmptyObject(data))){
          responseWishlistArray = data.wishlist;
        }
        createWishlistLocalStorageObj();
      },
      302: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          closeOnCancel: false,
          allowOutsideClick: false
        });
        $('.swal2-confirm').click(function () {
          location.reload(true);
        });
      },
      401:function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
      },
      403: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
      },
      400: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });

      },
      500: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
      }
    }
  }).fail(function(data, textStatus, xhr){
    console.log(data.getResponseHeader('x-request-id'));
  });

}

function createCartLocalStorageObj(){
  localStorageCartLineItemsArray = [];
  if(!($.isEmptyObject(responseCartObj))){
    if(responseCartObj.cart_lineitems !== null && responseCartObj.cart_lineitems !== 'undefined'){
      var cartLineItemsArray = responseCartObj.cart_lineitems;
      var cartLineItemsArrayLength = cartLineItemsArray.length;
      var i;
      if(cartLineItemsArrayLength > 0){
        for(i=0;i<cartLineItemsArrayLength;i++){
          var cartLineItemObj = cartLineItemsArray[i];
          if(!($.isEmptyObject(cartLineItemObj))){
            var variantsArray = cartLineItemObj.variants;
            var variantsArrayLength = variantsArray.length;
            var j;
            if(variantsArrayLength>0){
              for(j=0;j<variantsArrayLength;j++){
                var variantObj = variantsArray[j];
                if(!($.isEmptyObject(variantObj))){
                  var productId = "";
                  var variantId = "";
                  if(variantObj.product_id !== null){
                    productId = variantObj.product_id;
                  }
                  if(variantObj.id !== null){
                    variantId = variantObj.id;
                  }
                  var lineItemObj = {};
                  lineItemObj["productId"] = productId;
                  lineItemObj["variantId"] = variantId;
                  localStorageCartLineItemsArray.push(lineItemObj);
                }
              }
            }
          }
        }
      }
    }
  }
}

function createWishlistLocalStorageObj(){
  localStorageWishlistLineItemsArray = [];
  var wishlistArrayLength = responseWishlistArray.length;
  var i;
  if(wishlistArrayLength>0){
    for(i=0;i<wishlistArrayLength;i++){
      var wishlistLineItemObj = responseWishlistArray[i];
      if(!($.isEmptyObject(wishlistLineItemObj))){
        var productId = "";
        var variantId = "";
        var wishlistId = "";
        let isVariantArrayExists = wishlistLineItemObj.hasOwnProperty("variants");
        let productObj = {};
        if (isVariantArrayExists === true) {
          productObj = (wishlistLineItemObj.variants)[0];
        }

        if(productObj.product_id !== null){
          productId = productObj.product_id;
        }
        if(productObj.id !== null){
          variantId = productObj.id;
        }
        //         if(productObj.wishlist_id !== null){
        //           wishlistId = wishlistLineItemObj.wishlist_id;
        //         }
        var lineItemObj = {};
        lineItemObj["productId"] = productId;
        lineItemObj["variantId"] = variantId;
        lineItemObj["wishlistId"] = variantId;
        localStorageWishlistLineItemsArray.push(lineItemObj);
      }
    }
  }
}

function setLocalStorage(){
  var localStorageObj = {};
  localStorageObj["cartLinrItemsArray"] = localStorageCartLineItemsArray;
  localStorageObj["wishlistLineItemsArray"] = localStorageWishlistLineItemsArray;
  var jsonString = JSON.stringify(localStorageObj);
  if(typeof(Storage) !== 'undefined'){
    localStorage.setItem("productDetail",jsonString);
  }
}